import { MyAccountRoute } from "@/constants/routes/myAccount.ts"
import useLinkResolver from "@/lib/useLinkResolver.ts"
import TrackingService from "@/services/TrackingService.ts"
import { URLOpenListenerEvent } from "@capacitor/app/dist/esm/definitions"
import { Router } from "vue-router"

export const processAppUrlOpen = (
  event: URLOpenListenerEvent,
  router: Router,
) => {
  const url = new URL(event.url)

  const { navigateToUrl } = useLinkResolver(
    `${url.pathname}${url.search}`,
    router,
  )

  TrackingService.sendEvent("app_url_opened", { value: event.url })
  requestAnimationFrame(() => {
    navigateToUrl()
  })
}

export const redirectAfterLogin = async (
  redirectUrl: string,
  router: Router,
) => {
  // on native, we MAY have opened the app from a legacy URL while not
  // logged in, which will have landed us on the login page with that
  // legacy URL in our redirect parameter, and since it's legacy we
  // CANNOT just go straight there, we need to delegate to the link
  // resolver in case we need an IAB instead of a regular navigation
  const { navigateToUrl } = useLinkResolver(
    decodeURIComponent(redirectUrl),
    router,
  )

  const { didOpenBrowser } = await navigateToUrl()

  // if it opened an IAB, we will just have remained on the login page,
  // so load the homepage in the background.
  if (didOpenBrowser) {
    await router.replace(MyAccountRoute.home)
  }
}
